<template>
  <div style="display: inline-block;margin-right: 10px;">
    <input v-show="false" ref="file" type="file" @change="importExcel" />
    <el-button type="info" class="button-el-el" @click="onDerive">批量輸入</el-button>
  </div>
</template>

<script>
import {importStudentCodes} from "@/api/setting";
export default {
  props: {
    fileType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      contentData: [],
    };
  },
  methods: {
    onDerive() {
      this.$refs.file.click();
    },
    // 导入
    importExcel(file) {
      // 获取上传excel文件的信息
      const fileContent = file.target.files[0];
      // 获取文件类型
      // const types = file.name.split('.')[1]
      // const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt'].some(
      //   (item) => item === types
      // )
      // if (!fileContent) {
      //   if (!fileType) {
      //     alert('格式错误！请重新选择')
      //     return
      //   }
      // }
      this.importFile(fileContent);
    },
    // 文件数据的处理
    importFile(obj) {
      // 文件读取
      const reader = new FileReader();
      const _this = this;
      // 按字节读取文件内容，结果用ArrayBuffer对象表示
      reader.readAsArrayBuffer(obj);
      //  读取操作完成时触发的事件(reader.onload)
      reader.onload = function () {
        const buffer = reader.result;
        // Uint8Array 数组类型转化为16进制字符串
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = "";
        for (let i = 0; i < length; i++) {
          // 转码
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require("xlsx");
        // 获取excel表格中的表头
        const wb = XLSX.read(binary, {
          type: "binary",
        });
        // 获取excel表格数据
        // wb.SheetNames[0]:excel表格的第几个工作表格  wb.Sheets是获取工作表格数据
        // XLSX.utils.sheet_to_json 从工作表创建 JS 值数组的数组
        const outData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        const data = [...outData];
        // 定义转化完成的数据
        const arr = [];
        data.map((v) => {
          let obj = {
            number: v["StudentID"] || null,
            phone: v["Phone"] || null,
            chineseName: v["ChineseName"] || null,
            engName: v["EngName"] || null,
            given: v["Given"] || null,
            surname: v["Surname"] || null,
            teacherName: v["TeacherName"] || null,
          };
          arr.push(obj);
        });
        _this.contentData = arr;
        _this.importStudentCodes()
        
        
      };
    },
    importStudentCodes(){
      // importStudentCodes(this.contentData).then((res)=>{
      //   console.info(res.data)
      //   downloadFile(res.data,'userReport.csv')
      // })
      importStudentCodes(this.contentData).then((res)=>{
        console.info(res)
          this.$message({
            type: "success",
            message: res,
          });
          this.$emit("importExcel");
      }).finally(()=>{
        this.$refs.file.value = null
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.aa {
  display: inline-block;
}
.cursor {
  width: 20px;
  height: 20px;
  margin-right: 30px;
  border-left: 1px solid #aaa;
  border-right: 1px solid #fff;
}
</style>
